import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { useAppSelector } from "src/hooks/redux";
import { useSearchParams } from "react-router-dom";
import { EmptyList } from "../EmptyList";
import { twMerge } from "tailwind-merge";
import moment from "moment";
import { NotificationSendOWDCalendarButton } from "src/pages/DashboardPage/acadia/notificationPage/calendar_owd_index";
import { setLocalItem } from "src/utils/localStorage";
import { NotificationReportDrawer } from "./NotifyReportTableWithFilters";
import { ListFieldsType } from "src/api/config";
import { notificationsListName } from "src/api/config/notifications.config";
import { selectUsers } from "src/modules/users/selector";
import { useCallback, useEffect, useRef, useState } from "react";
import { isMobile } from "src/utils/device";

const OWDCalendarTable = (props: any) => {
  const { data, tableHeaderContent, typePeriod, setScrollDown, filters } = props;
  const [query, setQuery] = useSearchParams();
  const users: any = useAppSelector(selectUsers);
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileDevice(isMobile());
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const ITEMS_PER_PAGE = 10;
  const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  function openDocumentCard(id: number) {
    const newSearchParams = new URLSearchParams(query);
    if (isMobileDevice) {
      newSearchParams.set("documentCardMobile", id.toString());
    } else {
      newSearchParams.set("documentCard", id.toString());
    }
    setQuery(newSearchParams);
  }

  function handleClickNotificationCard(
    item: ListFieldsType[typeof notificationsListName]
  ) {
    const newSearchParams = new URLSearchParams(query);
    newSearchParams.set("notificationCard", item.id.toString());
    setQuery(newSearchParams);
  }

  const handleScroll = useCallback(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const { scrollTop, scrollHeight, clientHeight } = container;
    // Триггерим за 100px до конца для плавности
    if (scrollHeight - scrollTop - clientHeight < 100) {
      setScrollDown(true);
      setVisibleCount(prev => {
        const newCount = prev + ITEMS_PER_PAGE;
        return newCount >= data.length ? data.length : newCount;
      });
    }
  }, [data.length]);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;
    container.addEventListener('scroll', handleScroll, { passive: true });
    return () => container.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setVisibleCount(ITEMS_PER_PAGE);
  }, [filters]);

  return (
    <FlexCol className="w-full">
      <FlexCol className="relative">
        <div
          ref={scrollContainerRef}
          id="owd_calendar_wrapper"
          className="flex flex-col relative pb-5 overflow-x-auto bg-white rounded-lg table-custom shadow-custom scrollbar scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-w-2 scrollbar-thumb-[#D1D5DB] max-h-[calc(100vh-320px)] min-h-[65px]"
        >
          <FlexRow className="divide-x divide-[#D1D5DB] sticky-custom max-h-[65px] w-fit bg-white px-10 z-10">
            {Object.keys(tableHeaderContent).map((fieldKey, idx) => {
              const key: string = fieldKey;
              return (
                <TableHeaderColumn
                  key={fieldKey}
                  tableHeaderContent={tableHeaderContent[key]}
                  idx={idx}
                />
              );
            })}
          </FlexRow>
          <FlexCol id="owd_calendar_data" className="divide-y grow w-fit px-10">
            {data.map((item: any, idx: number) => (
              <FlexRow
                className="divide-x divide-[#D1D5DB] py-4 rounded-lg -mx-2 px-2"
                key={item.ID}
              >
                <FlexCol
                  style={item.style}
                  onClick={() => openDocumentCard(item.ID)}
                  className="break-words text-[#637381] cursor-pointer sticky left-0 z-20 bg-white pl-5"
                >
                  <span className="block text-sm font-normal not-italic text-[#637381]">
                    {item.Code}.{item.Index}
                  </span>
                  <span className="block text-sm font-normal not-italic text-[#012169]">
                    {item.Title}
                  </span>
                </FlexCol>
                {item.columnsData.map((column: any, idx: number) => (
                  <FlexCol
                    key={`${item.ID}_${idx}`}
                    className={twMerge(
                      "whitespace-pre-line w-full px-3",
                      idx === 0 && "border-none"
                    )}
                    style={column.style}
                  >
                    {column.data.map((owd: any) => (
                      <FlexRow
                        onClick={() => handleClickNotificationCard(owd)}
                        className={twMerge(
                          owd.colorClass,
                          "w-full rounded text-black justify-between mb-5 px-1 cursor-pointer gap-1"
                        )}
                      >
                        {/* <FlexCol
                          style={{ width: "91px" }}
                          className="font-medium whitespace-pre-line mr-[3px]"
                        >
                          {moment(owd.ReviewDate).format("DD.MM.YYYY")}
                        </FlexCol> */}
                        <FlexCol
                          style={{ width: "170px" }}
                          className="font-medium whitespace-pre-line"
                        >
                          {users[owd.EmployeeEmail] &&
                            users[owd.EmployeeEmail]["shortDisplayName"]}
                        </FlexCol>
                        <FlexCol
                          style={{ width: "170px" }}
                          className="font-medium whitespace-pre-line"
                        >
                          {users[owd.TestedEmployee] &&
                            users[owd.TestedEmployee]["shortDisplayName"]}
                        </FlexCol>
                        {/* <FlexCol
                          style={{ width: "91px" }}
                          className="font-medium whitespace-pre-line ml-[3px]"
                        >
                          
                          {owd.Completed &&
                            moment(owd.Completed).format("DD.MM.YYYY")}
                        </FlexCol> */}
                      </FlexRow>
                    ))}
                    {column.defaultDate &&
                      ((typePeriod.id === "year" &&
                        moment(column.defaultDate).unix() >=
                        moment().startOf("month").unix()) ||
                        ((typePeriod.id === "week" ||
                          typePeriod.id === "month") &&
                          moment(column.defaultDate)
                            .startOf("day")
                            .clone()
                            .unix() >=
                          moment().clone().startOf("day").unix())) && (
                        <NotificationSendOWDCalendarButton
                          title="Запланировать OWD"
                          type="inCalendar"
                          changeActive={(active: "get" | "send") =>
                            setLocalItem("notification_active", active)
                          }
                          initialSubmit={{
                            documents: item.ID
                              ? new Map([
                                [
                                  +item.ID,
                                  {
                                    id: +item.ID,
                                    code: {
                                      code: item.Code + "." + item.Index,
                                      name: item.Title,
                                    },
                                    publicationDate: item.PublicationDate,
                                  },
                                ],
                              ])
                              : new Map(),
                            reviewDate: moment(column.addDate).clone().toDate(),
                            comment: "",
                            employees: new Map(),
                            test: {
                              Questions: [],
                              IsQuestionFormOpen: false,
                              MinCorrectAnswersCount: 1,
                            },
                          }}
                        />
                      )}
                  </FlexCol>
                ))}
              </FlexRow>
            ))}
          </FlexCol>
          {query.has("notificationCard") && <NotificationReportDrawer />}
        </div>
      </FlexCol>
    </FlexCol >
  );
};

export default OWDCalendarTable;

export function TableHeaderColumn({ tableHeaderContent, idx }: any) {
  return (
    <FlexCol
      className={twMerge(
        "select-none pt-5 pb-5",
        (tableHeaderContent.title !== "Документ" && "px-3") ||
        "sticky left-0 z-20 bg-white pl-5",
        idx === 1 && "border-none"
      )}
      style={tableHeaderContent.style}
    >
      <FlexCol
        className={twMerge(
          tableHeaderContent.title !== "Документ" && "items-center"
        )}
      >
        <FlexRow className="font-medium whitespace-pre-line">
          <span className="first-letter:uppercase">
            {tableHeaderContent.title}
          </span>
        </FlexRow>
        {tableHeaderContent.title !== "Документ" && (
          <FlexRow className="font-medium whitespace-pre-line w-full justify-between px-1 gap-1">
            {/* <FlexCol
              style={{ width: "91px" }}
              className="font-medium whitespace-pre-line mr-[3px]"
            >
              <></>
            </FlexCol> */}
            <FlexCol
              style={{ width: "170px" }}
              className="font-medium whitespace-pre-line"
            >
              Кто проводит OWD
            </FlexCol>

            <FlexCol
              style={{ width: "170px" }}
              className="font-medium whitespace-pre-line"
            >
              Кому проводят OWD
            </FlexCol>
            {/* <FlexCol
              style={{ width: "91px" }}
              className="font-medium whitespace-pre-line ml-[3px]"
            >
              <></>
            </FlexCol> */}
          </FlexRow>
        )}
      </FlexCol>
    </FlexCol>
  );
}
